import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const LokalOrganizasyonReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [eventInfo, setEventInfo] = useState({
    organizationName: '',
    eventName: '',
    eventDate: new Date().toISOString().split('T')[0],
    location: ''
  });

  const [budget, setBudget] = useState([
    { category: '', description: '', plannedAmount: 0, actualAmount: 0, difference: 0 }
  ]);

  const [notes, setNotes] = useState('');

  useEffect(() => {
    const totalPlanned = budget.reduce((sum, item) => sum + item.plannedAmount, 0);
    const totalActual = budget.reduce((sum, item) => sum + item.actualAmount, 0);
    const totalDifference = totalPlanned - totalActual;

    onDataChange({
      ...eventInfo,
      budget,
      notes,
      totalPlanned,
      totalActual,
      totalDifference,
      date: new Date().toLocaleDateString()
    });
  }, [eventInfo, budget, notes, onDataChange]);

  const handleBudgetChange = (index, field, value) => {
    const newBudget = [...budget];
    newBudget[index][field] = value;
    if (field === 'plannedAmount' || field === 'actualAmount') {
      newBudget[index].difference = newBudget[index].plannedAmount - newBudget[index].actualAmount;
    }
    setBudget(newBudget);
  };

  const totalPlanned = budget.reduce((sum, item) => sum + item.plannedAmount, 0);
  const totalActual = budget.reduce((sum, item) => sum + item.actualAmount, 0);
  const totalDifference = totalPlanned - totalActual;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField label="Organization Name" name="organizationName" value={eventInfo.organizationName} onChange={(e) => setEventInfo({ ...eventInfo, organizationName: e.target.value })} placeholder="Organization name" required />
        <InputField label="Event Name" name="eventName" value={eventInfo.eventName} onChange={(e) => setEventInfo({ ...eventInfo, eventName: e.target.value })} placeholder="Event name" />
        <InputField label="Event Date" name="eventDate" type="date" value={eventInfo.eventDate} onChange={(e) => setEventInfo({ ...eventInfo, eventDate: e.target.value })} />
        <InputField label="Location" name="location" value={eventInfo.location} onChange={(e) => setEventInfo({ ...eventInfo, location: e.target.value })} placeholder="Event location" />
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Event Budget</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Category</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Description</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Planned</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Actual</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Difference</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {budget.map((item, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={item.category} onChange={(e) => handleBudgetChange(index, 'category', e.target.value)} placeholder="e.g., Venue" /></td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={item.description} onChange={(e) => handleBudgetChange(index, 'description', e.target.value)} placeholder="Details" /></td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={item.plannedAmount} onChange={(e) => handleBudgetChange(index, 'plannedAmount', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={item.actualAmount} onChange={(e) => handleBudgetChange(index, 'actualAmount', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2 text-right font-medium text-[#111418] dark:text-gray-100">${item.difference.toFixed(2)}</td>
                  <td className="p-2 text-center"><button onClick={() => setBudget(budget.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={budget.length === 1}><span className="material-symbols-outlined text-xl">delete</span></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setBudget([...budget, { category: '', description: '', plannedAmount: 0, actualAmount: 0, difference: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Budget Item</Button>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3 bg-gray-50 dark:bg-gray-900 p-4 rounded-lg">
          <div className="flex justify-between items-center"><span className="text-gray-600 dark:text-gray-400">Total Planned</span><span className="font-medium text-[#111418] dark:text-gray-100">${totalPlanned.toFixed(2)}</span></div>
          <div className="flex justify-between items-center"><span className="text-gray-600 dark:text-gray-400">Total Actual</span><span className="font-medium text-[#111418] dark:text-gray-100">${totalActual.toFixed(2)}</span></div>
          <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-700"><span className="text-lg font-bold text-[#111418] dark:text-gray-100">Budget Difference</span><span className={`text-lg font-bold ${totalDifference >= 0 ? 'text-green-600' : 'text-red-600'}`}>${totalDifference.toFixed(2)}</span></div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Event summary, attendance, feedback..." rows={3} />
    </div>
  );
};

export default LokalOrganizasyonReportForm;
